/**
 * @param param { [key:string]:any}
 * @param url {string}
 * @return {string}
 */
export const addQueryToUrl = function(param, url) {
  if (!url) return "";
  if (!param || !Object.keys(param).length) return url;
  let _url = url;
  // 有问号提出url并添加至obj，没问号用原url
  if (url.indexOf("?") > -1) {
    param = Object.assign(
      {},
      {
        ...param,
        ...getUrlQuery(url)
      }
    );
    _url = url.split("?")[0];
  }
  let result = "?";
  for (const key in param) {
    if (param[key] !== undefined && param[key] !== null) {
      result += `${key}=${param[key]}&`;
    }
  }
  // 去除最后一个& 并返回
  return `${_url}${result.slice(0, -1)}`;
};



// WEBPACK FOOTER //
// ./src/utils/util.js